// Catálogos compartidos por los módulos de EIA de proyecto (Leopold 1971 y
// Conesa 1997) — sugerencias de referencia, editables por la organización
// vía "allowAdditions" en los selects que las usan.
export const PROJECT_ACTIONS = [
  "Movimiento de suelos / excavación",
  "Construcción de infraestructura",
  "Operación de maquinaria",
  "Captación de agua",
  "Vertido de efluentes",
  "Generación de residuos",
  "Emisiones a la atmósfera",
  "Transporte y logística",
  "Almacenamiento de materiales/químicos",
  "Desmantelamiento / cierre",
];

export const ENVIRONMENTAL_FACTORS = [
  "Calidad del aire",
  "Calidad del agua superficial",
  "Calidad del agua subterránea",
  "Suelo",
  "Flora / vegetación",
  "Fauna",
  "Paisaje",
  "Ruido",
  "Población / salud",
  "Empleo / economía local",
];
